import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/')({
  loader: () => {
    redirect({ to: '/dashboard/high-yield-savings', throw: true });
  },
});
